<template>
    <Viewer class="upload-list" :options="{zoomRatio:0.2}" :images="files">
        <div class="upload-list-item"  v-for="(item,index) in files" :key="index">
            <template v-if="item.status === 'finished' || !isEdit">
                <img v-if="item.type==='img'" class="upload-img" :src="'/static/file/'+item.diskFileName" :alt="item.fileName">
                <div v-else class="upload-file" :class="uploadType(item.type)">
                    <a class="upload-name" :href="'/static/file/'+item.diskFileName" :download="item.fileName" target="_blank">{{item.fileName}}</a>
                </div>
            </template>
            <template v-else>
                <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
            </template>
            <span class="upload-remove" @click="handleRemove(item.fileName)" v-if="isEdit"><Icon type="ios-close" /></span>
        </div>

        <!--:format="['jpg','jpeg','png','gif','rar','zip','7z','doc','docx']"-->
        <Upload
                ref="upload"
                type="drag"
                action="/wdgc/upload"
                :show-upload-list="false"
                :on-format-error="handleFormatError"
                :default-file-list="uploadList"
                :on-success="handleUpload"
                :on-error="uploadFail"
                :max-size="10240"
                :on-exceeded-size="handleMaxSize"
                :before-upload="handleBeforeUpload"
                class="up-btn"
                v-if="isEdit"
        >
            <div>+</div>
        </Upload>
    </Viewer>
</template>
<script>
    import 'viewerjs/dist/viewer.css'
    import {component as Viewer} from "v-viewer"
    export default {
        components: {
            Viewer
        },
        data(){
            return{
                //上传列表
                files:[],
            };
        },
        props: {
            /*上传文件列表*/
            uploadList:{
                type: Array
            },
            isEdit:{
                type:Boolean,
                default:true
            },
        },
        mounted(){
            if(this.uploadList) {
                this.files = this.uploadList;
                // console.log(this.$refs.upload.fileList);
            }else {
                this.uploadList=this.files;
            }
            /*设置文件类型*/
            this.files.forEach((item)=>{
                item.type=this.handleSuffix(item.diskFileName);
            });
        },

        watch: {
            uploadList:function () {
                if(this.uploadList) {
                    /*设置文件类型*/
                    this.uploadList.forEach((item)=>{
                        item.type=this.handleSuffix(item.diskFileName);
                    });
                    this.$nextTick(()=>{
                        /*赋值*/
                        this.files = this.uploadList;
                    });
                }
            }
        },
        methods:{
            uploadType(type){
                let cstr='';
                switch (type) {
                    case 'yasuo':
                        cstr='upload-yasuo';
                        break;
                    case 'word':
                        cstr='upload-word';
                        break;
                    case 'excel':
                        cstr='upload-excel';
                        break;
                    case 'ppt':
                        cstr='upload-ppt';
                        break;
                    default:
                        cstr='upload-others';
                }
                return cstr;
            },
            //获取文件后缀
            handleSuffix(filename){
                //这里设置单个图片时的名称
                let reg=/\.(jpg|jpeg|png|bmp|gif|wmf)$/i;
                let yasuo=/\.(rar|zip|7z)$/i;
                let word=/\.(doc|docx)$/i;
                let excel=/\.(xls|xlsx|csv)$/i;
                let ppt=/\.(ppt|pps|pptx|ppsx|pot|ppa)$/i;
                if(reg.test(filename)){
                    return 'img';
                }else if(yasuo.test(filename)){
                    return 'yasuo';
                }else if(word.test(filename)){
                    return 'word';
                }else if(excel.test(filename)){
                    return 'excel';
                }else if(ppt.test(filename)){
                    return 'ppt';
                }else{
                    return 'others';
                }
            },
            //预览实例初始化后 打开预览
            inited (viewer) {
                this.$viewer = viewer;
                // this.$viewer.view();
            },
            //上传模块
            /*标签删除*/
            handleRemove(name){
                for(let i=0;i<this.files.length;i++){
                    if(this.files[i].fileName===name){

                        /*这里删除*/
                        this.files.splice(i,1);
                        /*发送更新值 以便父组件.sync接收*/
                        this.$emit('update:uploadList',this.files);
                        break;
                    }
                }
            },
            /*上传成功*/
            handleUpload(response, file){
                file.fileName = response.fileName;
                file.filePath = response.path;
                file.diskFileName = response.diskFileName;
                file.type=this.handleSuffix(file.diskFileName);
                delete file.response;
                this.files.push(file);
                this.$emit('update:uploadList',this.files);

            },
            /*上传失败*/
            uploadFail(){
                this.$Message.error('上传失败！');
            },
            /*文件过大*/
            handleMaxSize(file){
                this.$Notice.warning({
                    title: '文件过大',
                    desc: file.name + ' 文件太大,不能超过10M.'
                });
            },
            /*格式验证失败*/
            handleFormatError (file) {
                this.$Message.error('文件格式不支持！请上传图片、压缩包、word');
            },
            /*最多上传*/
            handleBeforeUpload(){
                // const check = this.files.length < 5;
                // if (!check) {
                //     this.$Notice.warning({
                //         title: '最多可上传5个'
                //     });
                // }
                // return check;
            },
        },
    };
</script>
<style scoped>
    .upload-list{
        display: inline-flex;display:-webkit-inline-flex;
        flex-wrap: wrap;
    }
    .upload-list-item{
        width:150px; height: 100px;
        border: 1px dashed #e4e4e4;
        position: relative;
        display: flex;display: -webkit-flex;justify-content: center;align-items: center;
        margin-right: 10px; margin-bottom: 10px;
    }
    .upload-img{
        max-width: 100%; max-height: 100%;
        overflow: hidden;
    }
    .upload-file{
        display: block;width: 100%; height: 100%;
        background-repeat: no-repeat;
        background-position: center 5px;
        background-size: 55px 55px;
    }
    .upload-name{
        margin-top: 68px;
        height:30px ;
        padding: 0 5px;
        color: #2d8cf0;
        line-height: 14px;font-size: 12px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: flex;
        display: -webkit-flex;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .upload-name:hover{
        text-decoration: underline;
    }
    .upload-yasuo{
        background-image: url("/src/assets/yasuo.png");
    }
    .upload-word{
        background-image: url("/src/assets/word.png");
    }
    .upload-excel{
        background-image: url("/src/assets/excel.png");
    }
    .upload-ppt{
        background-image: url("/src/assets/ppt.png");
    }
    .upload-others{
        background-image: url("/src/assets/others.png");
    }
    .up-btn{
        width: 150px; line-height: 98px; text-align: center;
        font-size: 35px;
        color: #999999;
        margin-bottom: 10px;
    }
    .up-btn:hover{
        color: #2d8cf0;
    }
    .upload-remove{
        position: absolute;right: -2px;top: -5px;
        font-size: 17px;
        line-height: 17px;
        cursor: pointer;
    }
</style>

